import { render, staticRenderFns } from "./touringManage.vue?vue&type=template&id=2d7945eb&"
import script from "./touringManage.vue?vue&type=script&lang=js&"
export * from "./touringManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports